<template>
	<div id="gitfAlertView">
		<div class='gitbottomView'>
			<van-row>
				<van-col span="6" v-for="(item,index) in giftList" :key="index">
					<div class="list" @click="selectGiftAction(item,index)" :class="index == selected?'on':''">
						<div class="img"><img :src="item.pic_url"></div>
						<p>{{item.name}}</p>
						<p class="money">{{item.price/100}}<span>元</span></p>
					</div>
				</van-col>
			</van-row>

			<div class="paybar">
				<div class="paynumber">
					<span>数量</span>
					<van-stepper @change="changeOnClick" v-model="value" :min="1" :max="10000" :step="1" />
				</div>
				<div class="paybutton">
					<span class="cost">合计: {{sumMoney}}元</span>
					<van-button size="small" @click='bugGifAction()'>支付</van-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import Vue from 'vue';
	import { Row, Col, Stepper, Button, Toast } from 'vant';
	Vue.use(Row).use(Col);
	Vue.use(Stepper);
	Vue.use(Button);
	Vue.use(Toast);
	import vxxData from '../../kits/data.js';
	import tool from '../../kits/Tools.js';
	import md5 from 'blueimp-md5';

	export default {
		data() {
			return {
				value: 1,
				sumMoney: 0,
				selected: -1,
				giftData: [],
				currentPrice: 0,
				currentGift: {},
				payData: {},
				ds_id:'',
			}
		},
		props: ["renum",'fans_id','giftList'],
		mounted() {
			this.ds_id = tool.getQueryDsId();
		},
		methods: {
			changeOnClick() {
				this.sumMoney = (this.currentPrice * this.value) / 100;
			},
			selectGiftAction(item, index) {
				this.selected = index;
				this.currentPrice = item.price;
				this.currentGift = item;
				this.sumMoney = (item.price * this.value) / 100;
			},
			closeAction() {
				this.selected = -1;
				this.currentGift = '';
				this.currentPrice = 0;
				this.value = 1;
				this.sumMoney = 0;
			},
			bugGifAction() {
				var that = this;
				if(this.value <= 0) {
					Toast('请输入大于等于1的数量');
					return;
				}
				let Base64 = require('js-base64').Base64;
				var url = tool.baseUrl() + "/gift/index/rewardGift";
				
				var option = {
					'ds_id': this.ds_id,
					'gift_id': this.currentGift.gift_id,
					'fans_id': this.fans_id,
					'nums': this.value
				};
				console.log(option)
				var data = JSON.stringify(option);
				var params = Base64.encode(data);
				var verifyCode = vxxData.verifyCode;
				var newstr = '';
				var tmp = params.substring(0, 3);
				var tmp1 = params.substring(3, params.length);
				newstr += (tmp + md5(data + verifyCode) + tmp1);
				newstr = "data=" + newstr;

				this.axios.post(url, newstr).then(function(data) {
					if(data.data.code == "200") {
						that.payData = data.data.data;
						that.weixinPay(that.payData);
					} else {
						Toast('购买礼物失败！');
					}
				}).catch(function(res) {
					Toast('购买礼物失败！');
				});
			},
			weixinPay(p) {
				var that = this;
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
						"appId": p.appId, //公众号名称，由商户传入     
						"timeStamp": String(p.timeStamp), //时间戳，自1970年以来的秒数     
						"nonceStr": p.nonceStr, //随机串     
						"package": p.package,
						"signType": p.signType, //微信签名方式：
						"paySign": p.paySign //微信签名 
					},
					function(res) {
						// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
						if(res.errMsg == "get_brand_wcpay_request:ok" || res.err_msg == "get_brand_wcpay_request:ok") {
							Toast('购买礼物成功！');
							that.closeAction();
						} else {
							that.closeAction();
						}
					}
				);
			}
		},
		watch: {
			renum: function() {
				this.closeAction();
			}
		}
	}
</script>

<style scoped>
	.gitbottomView {
		background: white;
		border-top: 1px solid #d6d6d6;
	}
	
	.van-col--6 {
		height: 100px;
		background: white;
		border-right: 1px solid #d6d6d6;
		border-bottom: 1px solid #d6d6d6;
	}
	
	.van-col--6:nth-child(4n) {
		border-right: none;
	}
	
	.gitbottomView .on {
		background-color: rgba(237, 203, 145, 0.3);
	}
	
	.list {
		width: 100%;
		height: 100%;
		text-align: center;
	}
	
	.list .img {
		width: 35px;
		height: 35px;
		padding-top: 10px;
		text-align: center;
		margin: 0 auto 7px;
		line-height: 35px;
	}
	
	.list .img img {
		max-width: 100%;
		max-height: 100%;
		vertical-align: middle;
	}
	
	.money {
		color: #999;
	}
	
	.paybar {
		background: white;
		padding: 10px 10px;
		display: flex;
		align-items: center;
	}
	
	.paynumber {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
	}
	
	.paynumber span {
		margin-right: 10px;
	}
	
	.paybutton {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		flex: 1;
	}
	
	.paybutton .cost {
		padding-right: 10px;
		color: #FF9239;
	}
	
	.van-button--small {
		color: white;
		background: #01b3e9;
		border: none;
	}
</style>


// WEBPACK FOOTER //
// giftAlertView.vue?2b643d72